import { applicationService } from './application-service';
import { securityGroupsService } from './security-groups-service';
import { webhookService } from './webhooks-service';

export const applicationsService = {
  ...applicationService,
  ...securityGroupsService,
  ...webhookService,
};
